import React, { Suspense, lazy, Fragment } from 'react';
import { connect } from 'react-redux';
import ProductDetailImageList from "./ProductDetailImageList";
import ProductPresetPanel from "../ProductPresetPanel/ProductPresetPanel";
import ProductDetailCustomText from "../ProductDetailCustomText";
//import ProductDetailPages from "./ProductDetailPages";
import {FormattedMessage} from 'react-intl';

const ProductDetailPages = lazy(() => import('./ProductDetailPages'));

const ProductAccordion = props => {
    return (
        (props.pageCount!==2) && ([1,5,6,80,81].indexOf(props.productId)===-1)? <Fragment>
            <ProductDetailImageList />
            <ProductPresetPanel /> {/* @NOTE: If has preset then cannot has upload my own, it will be conflict */}
            <ProductDetailCustomText />
        </Fragment>:props.artworks?<Suspense fallback={<div>Loading...</div>}>
            <ProductDetailPages />
        </Suspense>:<div className="accordion">
            <div className="card border-right-0 border-top-0 border-left-0 border-bottom">
                <div id="predefined" className="collapse order-2 show" aria-labelledby="headingPredefined"
                     data-parent="#product-custom-text" style={{marginBottom: '-10px'}}>
                    <ProductDetailImageList />
                    <ProductPresetPanel /> {/* @NOTE: If has preset then cannot has upload my own, it will be conflict */}
                    <ProductDetailCustomText />
                </div>

                <div className="small opener order-1" id="headingPredefined">
                    <a href="#" className="btn-link text-left"
                       data-toggle="collapse" data-target="#predefined" aria-expanded="true"
                       aria-controls="predefined">
                        Personalise instead &gt;
                    </a>
                </div>
            </div>

            <div className="card border-0">
                <div id="uploadmine" className="collapse order-2" aria-labelledby="headingUploadMine"
                     data-parent="#product-custom-text">
                    <Suspense fallback={<div>Loading...</div>}>
                    <ProductDetailPages />
                    </Suspense>
                </div>

                <div className="opener order-1" id="headingUploadMine">
                    <a href="#" className="btn-link text-left h6 font-weight-bold"
                       data-toggle="collapse" data-target="#uploadmine" aria-expanded="true"
                       aria-controls="uploadmine">
                        <FormattedMessage id = "uploadimage.uploadyours"  defaultMessage="Upload your design" /> &gt;
                    </a>
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = state => ({
    artworks: state.artworks,
    productId: state.productId,
    pageCount: state.pages.length
});

export default connect(mapStateToProps)(ProductAccordion);

